import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  standalone: true,
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  /**
   * Formats a duration in minutes using customizable hour/minute labels.
   * @param totalMinutes Duration in minutes
   * @param hoursLabel Label for hours (default: 'h')
   * @param minutesLabel Label for minutes (default: 'm')
   * @returns A string like "1h 30m" or "45m"
   */
  transform(totalMinutes: number | null | undefined, hoursLabel: string = 'h', minutesLabel: string = 'm'): string {
    if (totalMinutes == null || isNaN(totalMinutes as unknown as number)) {
      return '';
    }

    const h = Math.floor(totalMinutes / 60);
    const m = Math.floor(totalMinutes % 60);

    if (h === 0) {
      return `${m} ${minutesLabel}`;
    } else if (m === 0) {
      return `${h} ${hoursLabel}`;
    } else {
      return `${h} ${hoursLabel} ${m} ${minutesLabel}`;
    }
  }
}
